import Repository from '@/repositories/repository'

const IBPortalRepository = {
  async getIBPortalData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('ib-portal', 'page', params)
  }
}

export default IBPortalRepository
